// components/SEO.jsx
import { Helmet } from "react-helmet-async";

const DEFAULT_IMAGE = "https://kinewsstudiolimited.co.uk/kinews-logo.jpg";

export default function SEO({
  title,
  description,
  url,
  image = DEFAULT_IMAGE,
}) {
  return (
    <Helmet>
      {/* Basic */}
      <title>{title}</title>
      <meta name="description" content={description} />

      {/* Open Graph */}
      <meta property="og:type" content="website" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={image} />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />

      {/* Canonical */}
      <link rel="canonical" href={url} />

      <meta name="robots" content="index, follow" />
    </Helmet>
  );
}